import * as cohort from '../../actionTypes/Cohort/Cohort';

const initialCohortOrgState = {
  loading: false,
  cohortsOrganizations: [],
};

export default function cohortsOrgsReducer(state = initialCohortOrgState, action) {
  switch (action.type) {
    case cohort.GET_COHORT_ORGANIZATIONS:
      return { ...state, loading: false, cohortsOrganizations: action.cohortsOrganizations };
    case cohort.GET_COHORT_ORGANIZATIONS_LOADING:
      return { ...state, loading: true, };
    default:
      return state;
  }
}
